/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class s{constructor(s,t){this._moduleSingletons=s,this._syntaxModules=t}loadLibrary(s){if(null==this._syntaxModules)return null;const t=this._syntaxModules[s];return t?{syntax:t.script,uri:t.uri}:null}}export{s as ArcadeModuleLoader};
